import CloseIcon from 'svg/CloseIcon';
import { ButtonText } from 'components/Button';
import Modal from 'components/modals/Modal';

interface ContactCoachSuccessModalProps {
  isOpen: boolean;
  handleClose: () => void;
}

export default function ContactCoachSuccessModal({
  isOpen,
  handleClose,
}: ContactCoachSuccessModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      handleClose={handleClose}
      classNameMaxWidth="max-w-[40rem]"
      className="px-0"
    >
      {/* Header with close button */}
      <div className="flex h-[4.75rem] items-center justify-end  px-10 py-5">
        <ButtonText onClick={handleClose}>
          <CloseIcon className="h-6 w-6" />
        </ButtonText>
      </div>

      {/* Content */}
      <div className="flex flex-col items-center justify-start gap-12 px-10 pb-[6.5rem] pt-0">
        <img src="/images/players/check.png" alt="Check" className="h-[7.5rem] w-[7.5rem]" />

        <div className="flex w-full flex-col items-center gap-8 text-center">
          <h2 className="typography-product-display text-color-text-lightmode-primary dark:text-color-text-darkmode-primary">
            Message sent!
          </h2>
          <div className="flex flex-col gap-4">
            <p className="typography-product-body text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary">
              The coach will contact you via email.
            </p>
            <p className="typography-product-body text-color-text-lightmode-tertiary dark:text-color-text-darkmode-tertiary">
              If you need additional support, contact support@bounce.game
            </p>
          </div>
        </div>
      </div>
    </Modal>
  );
}
